import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './i18n';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ProtectedRoute from './components/ProtectedRoute';
import SessionGate from './components/SessionGate';
import HomePage from './pages/HomePage';
import FindByRequest from './pages/FindByRequest';
import HousingDetail from './pages/HousingDetail';
import AdminPage from './pages/AdminPage';
import UniversitySearchPage from './pages/UniversitySearchPage';
import AddressSearchPage from './pages/AddressSearchPage';
import CalendarPage from './pages/CalendarPage';
import DashboardPage from './pages/DashboardPage';
import DataGridPage from './pages/DataGridPage';
import PropertyManagerPage from './pages/PropertyManagerPage';
import SessionManagerPage from './pages/SessionManagerPage';
import UserBookingPage from './pages/UserBookingPage';
import SavedPropertiesPage from './pages/SavedPropertiesPage';
import PropertyFacetsPage from './pages/PropertyFacetsPage';
import ScrollToTopButton from './components/ScrollToTopButton';

function App() {
  return (
    <Router>
      <div className="flex flex-col min-h-screen">
        <Navbar />
        <main className="flex-grow">
          <Routes>
            {/* Public routes - protected by SessionGate */}
            <Route path="/" element={<SessionGate><HomePage /></SessionGate>} />
            <Route path="/find-by-request" element={<SessionGate><FindByRequest /></SessionGate>} />
            <Route path="/housing/:id" element={<SessionGate><HousingDetail /></SessionGate>} />
            <Route path="/saved" element={<SessionGate><SavedPropertiesPage /></SessionGate>} />
            <Route path="/facets" element={<SessionGate><PropertyFacetsPage /></SessionGate>} />
            
            {/* Admin protected routes */}
            {/* /admin redirects to /dashboard */}
            <Route
              path="/admin"
              element={<Navigate to="/dashboard" replace />}
            />
            <Route
              path="/admin/create-property"
              element={
                <ProtectedRoute>
                  <AdminPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/session-manager"
              element={
                <ProtectedRoute>
                  <SessionManagerPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <DashboardPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/data-grid"
              element={
                <ProtectedRoute>
                  <DataGridPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/property-manager"
              element={
                <ProtectedRoute>
                  <PropertyManagerPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/calendar"
              element={
                <ProtectedRoute>
                  <CalendarPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/university"
              element={
                <ProtectedRoute>
                  <UniversitySearchPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/address"
              element={
                <ProtectedRoute>
                  <AddressSearchPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/user-bookings"
              element={
                <ProtectedRoute>
                  <UserBookingPage />
                </ProtectedRoute>
              }
            />
          </Routes>
        </main>
        <Footer />
        <ScrollToTopButton />
      </div>
    </Router>
  );
}

export default App;